import { render } from "./ThresholdConfigModal.vue?vue&type=template&id=03e8ef08&scoped=true&ts=true"
import script from "./ThresholdConfigModal.vue?vue&type=script&lang=ts"
export * from "./ThresholdConfigModal.vue?vue&type=script&lang=ts"

import "./ThresholdConfigModal.vue?vue&type=style&index=0&id=03e8ef08&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e8ef08"]])

export default __exports__